import SitePage from "@/components/application/site-page";
import { ReactNode } from "react";

function TermsPage() {
  return (
    <>
      <h1>Terms & Conditions</h1>
      <p>
        <strong>Last updated:</strong> July 26, 2026
      </p>

      <p>
        Welcome to <strong>BrickGestor</strong>! These Terms & Conditions
        explain how you can use our service. By accessing or using BrickGestor,
        you agree to these terms. If you don’t agree, please don’t use the
        service.
      </p>

      <h2>1. Who we are</h2>
      <p>
        BrickGestor is a software platform that helps LEGO sellers and AFOLs
        manage inventory, prices, and sales internally.
      </p>
      <p>
        BrickGestor is operated by{" "}
        <strong>Gatito Pirata Technologies EIRL</strong>, a company organized
        under the laws of Peru, RUC 20616175221.
      </p>
      <p>
        BrickGestor is <strong>not a marketplace</strong> and does not process
        payments between sellers and buyers.
      </p>

      <h2>2. Who can use BrickGestor</h2>
      <p>
        You must be at least 18 years old and legally able to enter into
        contracts to use BrickGestor.
      </p>

      <h2>3. Your account</h2>
      <p>
        To use most features, you need to create an account. You are responsible
        for:
      </p>
      <ul>
        <li>Providing accurate information</li>
        <li>Keeping your login details secure</li>
        <li>All activity that happens under your account</li>
      </ul>

      <h2>4. Plans, pricing, and payments</h2>
      <p>
        BrickGestor offers free and paid plans. Features, limits, and prices are
        shown on our website.
      </p>
      <p>
        Paid plans are billed in advance on a recurring basis (monthly or
        yearly). If a payment fails, access to paid features may be paused.
      </p>

      <h2>5. Free plans and limits</h2>
      <p>
        Free or trial plans may have limits (for example, number of products,
        users, or features).
      </p>
      <p>We may change or discontinue free plans at any time.</p>

      <h2>6. Your data</h2>
      <p>
        You own all the data you upload to BrickGestor, including inventory,
        prices, and descriptions.
      </p>
      <p>
        By using BrickGestor, you allow us to store and process your data only
        as needed to run and improve the service.
      </p>
      <p>
        Personal data is processed in accordance with Peruvian Law N.° 29733,
        Ley de Protección de Datos Personales, as described in our{" "}
        <a href="/privacy">Privacy Policy</a>.
      </p>
      <p>
        You are responsible for making sure your data is accurate and lawful.
      </p>

      <h2>7. What you can’t do</h2>
      <p>Please don’t use BrickGestor to:</p>
      <ul>
        <li>Break the law or commit fraud</li>
        <li>Attack, overload, or reverse-engineer the service</li>
        <li>Upload malware or harmful content</li>
        <li>Access accounts or data that aren’t yours</li>
      </ul>

      <h2>8. Service availability</h2>
      <p>
        We do our best to keep BrickGestor running smoothly, but we can’t
        promise it will always be available or error-free.
      </p>
      <p>
        We may perform maintenance, updates, or temporary shutdowns when needed.
      </p>

      <h2>9. Intellectual property</h2>
      <p>
        BrickGestor, including its software, branding, and design, belongs to
        <strong> Gatito Pirata Technologies EIRL</strong>.
      </p>
      <p>
        You may not copy, resell, or misuse any part of the service without
        permission.
      </p>

      <h2>10. Cancellation and termination</h2>
      <p>You can cancel your account at any time.</p>
      <p>
        We may suspend or close accounts if these terms are violated or if there
        are unpaid fees.
      </p>

      <h2>11. Disclaimer</h2>
      <p>
        BrickGestor is provided “as is” and “as available.” We don’t guarantee
        it will fit every specific use case or that it will always be
        uninterrupted.
      </p>

      <h2>12. Liability</h2>
      <p>
        To the maximum extent allowed by law, BrickGestor and Gatito Pirata
        Technologies EIRL are not responsible for indirect or consequential
        damages, lost profits, or data loss.
      </p>
      <p>
        Our total liability will not exceed the amount you paid us in the last
        12 months.
      </p>

      <h2>13. Consumer rights (Peru)</h2>
      <p>
        Nothing in these terms limits your rights under Peruvian consumer
        protection laws, including Ley N.º 29571.
      </p>

      <h2>14. Changes to these terms</h2>
      <p>
        We may update these Terms & Conditions from time to time. When we do,
        we’ll update the date at the top of this page.
      </p>
      <p>Continuing to use BrickGestor means you accept the updated terms.</p>

      <h2>15. Law and jurisdiction</h2>
      <p>These terms are governed by the laws of the Republic of Peru.</p>
      <p>
        Any disputes will be handled by the courts of Lima, Peru, unless
        consumer law requires otherwise.
      </p>

      <h2>16. Contact</h2>
      <p>If you have questions about these terms, you can contact us at:</p>
      <p>
        <strong>Gatito Pirata Technologies EIRL</strong>
        <br />
        RUC: 20616175221
        <br />
        Email: brickgestor@gatitopirata.com
      </p>

      <p>
        <em>
          BrickGestor is an independent product and is not affiliated with or
          endorsed by the LEGO Group.
        </em>
      </p>
    </>
  );
}

TermsPage.layout = (page: ReactNode) => <SitePage children={page} />;

export default TermsPage;
